export default "__VITE_ASSET__DRK9pQLC__"